import React, { Component } from "react";
import { connect } from 'react-redux';
import ReactStars from 'react-stars';
import ReactAutocomplete from 'react-autocomplete';
import 'moment/locale/ru';
import PlacesAutocomplete from 'react-places-autocomplete';
import Textarea from 'react-textarea-autosize';

class SettingsForm extends Component {

    render() {

        const {
            errorMessages,
            autocompleteCamera,

            formEdit,
            onSubmit,
            onEdit,
            handleOnChange,
            handleObject,
            handleCamera,
            handleCameraSelect,
            handleCameraFocus,
            handleChangeAddressText,
            getGeoCodeByAddress,
            handleMethod,
            handleMethodType,
            handleMethodSelect,
            openNewMethodModal,

            default_order_address_text,

            default_order_over_days,
            default_order_order_time_at,
            default_order_order_time_end_at,

            default_order_object_type,
            default_order_order_method_value,
            default_order_order_method_type,
            order_method_autocompete,
            default_order_address_comment,

            createMethodButtonShow,
            createMethodStatus,

            camera_requirementValue,
            default_order_contractor_minimal_rating,
            default_order_allow_upload_max_radius,
            default_order_contractor_count,
            default_order_auction_step,
            default_order_auction_time,
            default_order_allow_upload_results_from_web,
            default_order_auction_set_contractor,
            default_order_increase_price,
            default_order_decrease_price,

            comment,
            is_orders_always_public,
            default_order_is_auction,
        } = this.props;

        const inputProps = {
            placeholder: 'Район или радиус поиска на карте',
            value: default_order_address_text,
            onChange: (address) => handleChangeAddressText(address),
        }

        const {order_object_type, order_method_type, cameras} = this.props;

        return(
            <div className="white-block-content">

                <ul className="data-with-labels">
                    <li>
                        <h3 className="form-title" style={{border:0,padding:0}}>Место и время</h3>
                    </li>
                    <li className="google-maps-input-parent" style={{zIndex: 3}}>
                        <label htmlFor="">Место</label>
                        {
                            formEdit ?
                            <PlacesAutocomplete
                                inputProps={inputProps}
                                highlightFirstSuggestion
                                onSelect={(e) => getGeoCodeByAddress(e)}
                            />
                            :
                            <input
                                type="text"
                                className="value"
                                disabled={true}
                                value={default_order_address_text === "" ? "Место не указано" : default_order_address_text}
                                />
                        }
                    </li>
                    <li className="google-maps-input-parent">
                        <label htmlFor="">Комментарий к адресу</label>
                        <input
                            type="text"
                            placeholder="Комментарий к адресу"
                            className="value"
                            disabled={formEdit ? false : true}
                            value={default_order_address_comment}
                            onChange={(e) => handleOnChange(e.target.value, 'default_order_address_comment')}
                        />
                    </li>
                    <li>
                        <div className="settings-row">
                            <div>
                                <label htmlFor="">Дата</label>
                                <div>
                                    <select
                                        value={default_order_over_days}
                                        onChange={(e) => handleOnChange(e.target.value, 'default_order_over_days')}
                                        className="form-select"
                                        style={{width:'160px'}}
                                        disabled={formEdit ? false : true}
                                        >
                                        <option value="0">Сегодня</option>
                                        <option value="1">Завтра</option>
                                        <option value="2">Послезавтра</option>
                                        <option value="3">Через 2 дня</option>
                                    </select>
                                </div>
                            </div>
                            <div>
                                <label htmlFor="">Время</label>
                                <div style={{display:'flex',flexDirection:'row'}}>
                                    <div>
                                        <label style={{marginRight:'10px'}} htmlFor="">C</label>
                                        <input
                                            type="time"
                                            className="value"
                                            disabled={formEdit ? false : true}
                                            value={default_order_order_time_at}
                                            onChange={(e) => handleOnChange(e.target.value, 'default_order_order_time_at')}
                                            />
                                    </div>
                                    <div>
                                        <label style={{marginRight:'10px'}} htmlFor="">До</label>
                                        <input
                                            type="time"
                                            className="value"
                                            disabled={formEdit ? false : true}
                                            value={default_order_order_time_end_at}
                                            onChange={(e) => handleOnChange(e.target.value, 'default_order_order_time_end_at')}
                                            />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <h3 className="form-title">Как снимать</h3>
                    </li>
                    <li>
                        <div style={{display:'flex',flexDirection:'column'}}>
                            <label htmlFor="">Тип цели съемки</label>
                            <select
                                value={default_order_object_type}
                                onChange={(e) => handleObject(e.target.value)}
                                className="form-select"
                                style={{width:'160px'}}
                                disabled={formEdit ? false : true}
                                >
                                {
                                    order_object_type.results.map(elem =>
                                        <option key={elem.id} value={elem.id}>{elem.title}</option>
                                    )
                                }
                            </select>
                        </div>
                    </li>
                    <li>
                        <div className="settings-row">
                            <div>
                                <label htmlFor="">Способ съемки</label>
                                <div>
                                    <select
                                        value={default_order_order_method_type}
                                        onChange={(e) => handleMethodType(e.target.value, 'default_order_order_method_type')}
                                        className="form-select"
                                        style={{width:'160px'}}
                                        disabled={formEdit ? false : true}
                                        >
                                        {
                                            order_method_type.results.map(elem =>
                                                <option key={elem.id} value={elem.id}>{elem.title}</option>
                                            )
                                        }
                                    </select>
                                </div> 
                            </div>
                            <div style={{width:'50%'}}>
                                <label htmlFor="">Метод съемки</label>
                                <div style={{position:'relative'}}>

                                    <ReactAutocomplete
                                        inputProps={{
                                        //    onFocus: (e) => this.handleCameraFocus(e.target.value),
                                            placeholder: "Метод съемки"
                                        }}
                                        wrapperStyle={{display:'block'}}
                                        items={Object.keys(order_method_autocompete).map(item => order_method_autocompete[item])}
                                        renderInput={(props) => <input disabled={formEdit ? false : true} style={{width:'100%'}} className="value" {...props}/>}
                                        shouldItemRender={(item, value) => item.title.toLowerCase().indexOf(value.toLowerCase()) > -1}
                                        getItemValue={item => item.title}
                                        renderItem={(item, highlighted) =>
                                            <div
                                                key={item.id}
                                                style={{ backgroundColor: highlighted ? '#eee' : 'transparent'}}>
                                                {item.title}
                                            </div>
                                        }
                                        renderMenu={(items, value) =>{
                                            return <div className="autocomplete-dropdown" children={items}/>
                                        }}
                                        value={default_order_order_method_value}
                                        onChange={(e) => handleMethod(e.target.value)}
                                        onSelect={(value, item) => handleMethodSelect(item)}
                                    />

                                    {
                                        formEdit && default_order_order_method_value.trim().length &&
                                        createMethodButtonShow
                                        ?
                                        <button className="add-method-button" style={{position:'absolute',top:0,right:0,height:'28px'}}
                                            onClick={(e) => {
                                                    e.preventDefault();
                                                    openNewMethodModal()
                                                }
                                            }
                                        >
                                            {createMethodStatus === 'edit' ? 'Редактировать метод' : 'Создать новый метод'}
                                        </button>
                                        : null
                                    }

                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <label>Уточнение к методу</label>

                        <div className="width100 textarea-style-container" style={{
                                marginBottom:'30px',
                                minHeight: '25px',
                                paddingBottom: '10px'
                            }}>
                            <Textarea
                                placeholder="Уточнение"
                                className="width100"
                                defaultValue={comment || ''}
                                value={comment}
                                style={{backgroundColor:'#fff', color: '#383838'}}
                                disabled={formEdit ? false : true}
                                onChange={(e) => handleOnChange(e.target.value, 'comment')}
                            />
                        </div>
                    </li>
                    <li>
                        <h3 className="form-title">Требования к исполнителям:</h3>
                    </li>
                    <li>
                        <label>Количество исполнителей</label>
                        <input
                            type="number"
                            className="value"
                            min="1"
                            style={{width:'180px'}}
                            disabled={formEdit ? false : true}
                            value={default_order_contractor_count}
                            onChange={(e) => handleOnChange(e.target.value, 'default_order_contractor_count')}
                            />
                    </li>
                    <li>
                        <label>Аппарат</label>
                            
                        <ReactAutocomplete
                            inputProps={{
                                onFocus: (e) => handleCameraFocus(e.target.value),
                                placeholder: "Требования к аппарату"
                            }}
                            wrapperStyle={{display:'block',position:'relative'}}
                            items={Object.keys(autocompleteCamera).map(item => autocompleteCamera[item])}
                            renderInput={(props) => <input disabled={formEdit ? false : true} style={{width:'100%'}} className="value" {...props}/>}
                            shouldItemRender={(item, value) => item.title.toLowerCase().indexOf(value.toLowerCase()) > -1}
                            getItemValue={item => item.title}
                            renderItem={(item, highlighted) =>
                                <div
                                    key={item.id}
                                    style={{ backgroundColor: highlighted ? '#eee' : 'transparent'}}>
                                    {item.title}
                                </div>
                            }
                            renderMenu={(items, value) =>{
                                return <div className="autocomplete-dropdown" children={items}/>
                            }}
                            value={camera_requirementValue}
                            onChange={(e) => handleCamera(e.target.value)}
                            onSelect={(value, item) => handleCameraSelect(item)}
                        />

                    </li>
                    <li>
                        <label>Допустимый радиус съёмки (м)</label>
                        <input
                            type="number"
                            className="value"
                            placeholder='Значение в метрах'
                            disabled={formEdit ? false : true}
                            value={default_order_allow_upload_max_radius}
                            onChange={(e) => handleOnChange(e.target.value, 'default_order_allow_upload_max_radius')}
                            />
                    </li>
                    <li>
                        <label>Класс исполнителя</label>
                        <div style={{display:'flex', alignItems:'center'}}>
                            <ReactStars
                                // edit={!formEdit ? false : true}
                                className="create-order-star"
                                count={5}
                                onChange={(value) => {
                                    let newState = (value === 1 && default_order_contractor_minimal_rating === 1) ? 0 : value;
                                    handleOnChange(newState, 'default_order_contractor_minimal_rating')
                                }}
                                size={32}
                                value={default_order_contractor_minimal_rating}
                                half={false}
                                color2={'#ffd700'}
                            />

                            {
                                formEdit && default_order_contractor_minimal_rating ?
                                <div onClick={() => handleOnChange(0, 'default_order_contractor_minimal_rating')}
                                    style={{fontSize: '13px', color: 'red',marginLeft:'15px',cursor:'pointer'}}>Сбросить рейтинг</div>
                                : null
                            }
                        </div>
                    </li>
                    <li>
                        <h3 className="form-title">Подбор исполнителя:</h3>
                    </li>
                    <li>
                        <label>Торги начинаются за</label>
                        <select
                            value={default_order_auction_time}
                            onChange={(e) => handleOnChange(e.target.value, 'default_order_auction_time')}
                            className="form-select"
                            style={{width:'180px'}}
                            disabled={formEdit ? false : true}
                            >
                            <option value="360">6 часов</option>
                            <option value="480">8 часов</option>
                            <option value="600">10 часов</option>
                            <option value="720">12 часов</option>
                            <option value="900">15 часов</option>
                            <option value="1200">20 часов</option>
                            <option value="1440">24 часа</option>
                        </select>
                    </li>

                    <li>
                        <label>Шаг торгов ожидание исполнителя (если с торгами)</label>
                        <select
                            value={default_order_auction_step}
                            onChange={(e) => handleOnChange(e.target.value, 'default_order_auction_step')}
                            className="form-select"
                            style={{width:'180px'}}
                            disabled={formEdit ? false : true}
                            >
                            <option value="15">15 минут</option>
                            <option value="30">30 минут</option>
                            <option value="45">45 минут</option>
                            <option value="60">1 час</option>
                            <option value="90">1 час 30 минут</option>
                            <option value="120">2 часа</option>
                        </select>

                        {
                            errorMessages && errorMessages.default_order_auction_step 
                            ? errorMessages.default_order_auction_step.map((text, index) =>
                                <span key={index} className="input-error-text">{text}</span>
                            )
                            : ''
                        }                               
                    </li>   

                    <li>
                        <label htmlFor="">Назначение исполнителя</label>
                        <select
                            value={default_order_auction_set_contractor}
                            onChange={(e) => handleOnChange(e.target.value, 'default_order_auction_set_contractor')}
                            className="form-select"
                            style={{width:'180px'}}
                            disabled={formEdit ? false : true}
                            >
                            <option value="5">5 минут</option>
                            <option value="15">15 минут</option>
                            <option value="30">30 минут</option>
                            <option value="45">45 минут</option>
                            <option value="60">1 час</option>
                            <option value="90">1 час 30 минут</option>
                            <option value="120">2 часа</option>
                            <option value="180">3 часа</option>
                            <option value="240">4 часа</option>
                            <option value="360">6 часов</option>
                            <option value="480">8 часов</option>
                            <option value="720">12 часов</option>
                            <option value="960">16 часов</option>
                            <option value="1440">24 часов</option>
                        </select>
                    </li>
                    <li>
                        <label className="info-label" htmlFor="" style={{display:'flex',alignItems:'center'}}>
                            Повышение цены при необходимости
                        </label>
                        <input
                            type="number"
                            step=".10"
                            min={0}
                            className="value"
                            style={{width:'180px'}}
                            disabled={formEdit ? false : true}
                            value={default_order_increase_price}
                            onChange={(e) => handleOnChange(e.target.value, 'default_order_increase_price')}
                            />
                    </li>   
                    <li>
                        <label className="info-label" htmlFor="" style={{display:'flex',alignItems:'center'}}>
                            Понижение цены в торгах при необходимости
                        </label>
                        <input
                            type="number"
                            className="value"
                            style={{width:'180px'}}
                            step=".10"
                            min={0}
                            disabled={formEdit ? false : true}
                            value={default_order_decrease_price}
                            onChange={(e) => handleOnChange(e.target.value, 'default_order_decrease_price')}
                            />
                    </li>
                    <li>
                        <div className={formEdit ? "checkboxes checkboxes_align-left" : "checkboxes checkboxes_align-left disabled"}>
                            <label
                                className="c-form__label"
                                htmlFor="always_public"
                                >
                                <label className="custom-radio">
                                    <input
                                        disabled={formEdit ? false : true}
                                        checked={is_orders_always_public}
                                        className="value"
                                        type="checkbox"
                                        id="always_public"
                                        onChange={(e) => handleOnChange(is_orders_always_public ? false : true, 'is_orders_always_public')}
                                        />
                                    <div></div>
                                </label>
                                <span className="text">Заказы всегда общедоступны</span>
                            </label>
                        </div>
                    </li>
                    <li>
                        <div className={formEdit ? "checkboxes checkboxes_align-left" : "checkboxes checkboxes_align-left disabled"}>
                            <label className="c-form__label" htmlFor="orders_auction">
                                <label className="custom-radio">
                                    <input
                                        disabled={formEdit ? false : true}
                                        checked={default_order_is_auction ? false : true}
                                        className="value"
                                        type="checkbox"
                                        id="orders_auction"
                                        onChange={(e) => handleOnChange(default_order_is_auction ? false : true, 'default_order_is_auction')}
                                        />
                                    <div></div>
                                </label>
                                <span className="text">Все заказы проходят без торгов</span>
                            </label>
                        </div>
                    </li>  
                    <li>
                        <div className={formEdit ? "checkboxes checkboxes_align-left" : "checkboxes checkboxes_align-left disabled"}>
                            <label
                                className="c-form__label"
                                htmlFor="upload_from_computer"
                                >
                                <label className="custom-radio">
                                    <input
                                        disabled={formEdit ? false : true}
                                        checked={default_order_allow_upload_results_from_web}
                                        className="value"
                                        type="checkbox"
                                        id="upload_from_computer"
                                        onChange={(e) => handleOnChange(default_order_allow_upload_results_from_web ? false : true, 'default_order_allow_upload_results_from_web')}
                                        />
                                    <div></div>
                                </label>
                                <span className="text">Разрешить загрузку результатов с компьютера</span>
                            </label>
                        </div>
                    </li>                    

                </ul>

                <div className="actions">
                    <div className="big-button empty-button">
                        <button onClick={() => onEdit()}>
                            {formEdit ? 'Отмена' : 'Редактировать'}
                        </button>
                    </div>
                    {
                        formEdit
                        ?                         
                        <div className="big-button">
                            <button  onClick={(e) => onSubmit(e)}>Сохранить</button>
                        </div>
                        : null
                    }

                </div>

            </div>
        )
    }
}

export default connect(
    state => ({
        ...state,
        order_object_type: state.data.order_object_type,
        order_method_type: state.data.order_method_type
    })
)(SettingsForm);


// WEBPACK FOOTER //
// ./src/components/Account/SettingsForm.js